import { useMemo } from 'react';
import { isNil, omitBy } from 'lodash';

import { EMPTY_ARRAY } from '@e-socna/empty';

import { useIdFactory } from '../../../hooks/useIdFactory.hook';

import { isFormEmpty } from '../../utils/is-form-empty.util';

import { AddressFormTab } from '../enums/tab.enum';
import type { AddressForm_Address } from '../fragments/address.fragment';

export const useInitialValuesFactory = (
  pInitialValues?: Partial<AddressForm_Address> | null,
) => {
  const { generateId } = useIdFactory();

  const initialValues: AddressForm_Address = useMemo(() => {
    const enabledSteps: AddressFormTab[] = [
      ...(!isFormEmpty({ node: pInitialValues?.postalInfo })
        ? [AddressFormTab.PostalInfo]
        : EMPTY_ARRAY),
      ...(!isFormEmpty({
        node: pInitialValues?.locationInfo,
        ignore: ['_id', '__typename', 'projectionId'],
      })
        ? [AddressFormTab.LocationInfo]
        : EMPTY_ARRAY),
      ...(!isFormEmpty({ node: pInitialValues?.cadastralInfo })
        ? [AddressFormTab.CadastralInfo]
        : EMPTY_ARRAY),
    ];

    return {
      __typename: 'Address' as const,
      _id: generateId(),
      enabledSteps,
      typeIds: EMPTY_ARRAY,
      ...omitBy(pInitialValues, isNil),
    };
  }, [generateId, pInitialValues]);

  return { initialValues };
};
